export enum TransactionRuleType {
  TAGGING = 'tagging',
  MAPPING_TO_SMART_TRANSACTION = 'mapping_to_smart_transaction',
}

export enum TransactionRuleCriteriaType {
  CONNECTOR = 'connector',
  ACCESS_METHOD = 'method',
  ACCOUNT_TYPE = 'account type',
  TRANSACTION_TYPE = 'transaction type',
  DESCRIPTION = 'description',
  STATUS = 'status',
  ACCOUNT_NAME = 'account',
  ACCOUNT_NUMBER = 'account number',
  AMOUNT = 'amount',
  TRANSACTION_DATE = 'transaction date',
  // CUSTOM_FIELD = 'custom field',
  CATEGORY = 'category',
  SUBCATEGORY = 'subcategory',
}
